// PRISM — vibrant gradient cards. Near-white accordion cards floating on a
// 135° gradient built from the brand accent into deep indigo (#312d85).
// Card text uses fixed light-mode ink/sub literals because the cards stay
// white regardless of theme; the wrapper gradient uses ctx.tokens.accent
// (CSS vars can't be rebuilt inside gradients by the theme engine).
function itemHtml(ctx, it) {
    return `<div class="fq-acc"${ctx.reveal(it.idx)}>
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="prism-p-${it.idx}">
    <span class="fq-q">${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="prism-p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const prism = {
    id: 'prism',
    name: 'Prism',
    tag: 'Gradient cards',
    styleTag: 'Vibrant',
    description: 'White cards floating on a rich accent gradient. Vibrant without shouting \u2014 the gradient is built from your brand color automatically.',
    layout: 'cards',
    defaultAccent: '#7c3aed',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion', 'reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const grad = `linear-gradient(135deg, ${ctx.tokens.accent} 0%, #312d85 100%)`;
        const css = `
.FQM .fq-wrap{max-width:760px;margin:0 auto;padding:44px 36px 48px;border-radius:${ctx.v.radiusWrap};background:${grad}}
.FQM .fq-head{text-align:center;max-width:480px;margin:0 auto 30px}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:34px;font-weight:700;line-height:1.1;letter-spacing:-0.015em;color:#ffffff}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.6;color:rgba(255, 255, 255, 0.82)}
.FQM .fq-list{display:flex;flex-direction:column;gap:10px}
.FQM .fq-acc{background:rgba(255, 255, 255, 0.96);border-radius:${ctx.v.radiusCard}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:17px 20px}
.FQM .fq-q{font-size:16px;font-weight:500;line-height:1.4;color:#0b2a46}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 20px 18px;font-size:15px;line-height:1.6;color:#5b6b7e}
`;
        return { html, css };
    },
};
export default prism;
